function getQueryParamsAsObject() {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObject = {};

  // Iterate over the URLSearchParams entries and populate the object
  for (const [key, value] of urlParams.entries()) {
    paramsObject[key] = value;
  }

  return paramsObject;
}

function fillUrlPlaceholdersSimple(
  templateUrl: string,
  queryParams: { [key: string]: string }
) {
  let filledUrl = templateUrl;
  function escapeRegExp(s: string) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  for (const key in queryParams) {
    const placeholder = `$\{urlquery.${key}}`;
    const value = queryParams[key];
    const regex = new RegExp(escapeRegExp(placeholder), 'g');
    filledUrl = filledUrl.replace(regex, value);
  }
  return filledUrl;
}

export function getFinalUrl(url: string) {
  const queryParams = getQueryParamsAsObject();
  return fillUrlPlaceholdersSimple(url, queryParams);
}
